var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 12,
    r: 9,
    stroke: "#2F2B3D",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5301 9.46967C10.2372 9.17678 9.76232 9.17678 9.46943 9.46967C9.17653 9.76256 9.17653 10.2374 9.46943 10.5303L10.5301 9.46967ZM13.4694 14.5303C13.7623 14.8232 14.2372 14.8232 14.5301 14.5303C14.823 14.2374 14.823 13.7626 14.5301 13.4697L13.4694 14.5303ZM14.5301 10.5303C14.823 10.2374 14.823 9.76256 14.5301 9.46967C14.2372 9.17678 13.7623 9.17678 13.4694 9.46967L14.5301 10.5303ZM9.46943 13.4697C9.17653 13.7626 9.17653 14.2374 9.46943 14.5303C9.76232 14.8232 10.2372 14.8232 10.5301 14.5303L9.46943 13.4697ZM9.46943 10.5303L13.4694 14.5303L14.5301 13.4697L10.5301 9.46967L9.46943 10.5303ZM13.4694 9.46967L9.46943 13.4697L10.5301 14.5303L14.5301 10.5303L13.4694 9.46967Z",
    fill: "#2F2B3D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.04945d43d700f6a28387f5cac678864d.svg";
export { ForwardRef as ReactComponent };